export default __webpack_public_path__ + "static/media/s1.f8a53c4c.svg";